module.exports = {
  title: 'AutoCongrats App Blog', // Required
  author: 'AutoCongrats App', // Required
  description: 'Make your contacts happy!',
  primaryColor: '#3498db', // Required
  showHeaderImage: true,
  showShareButtons: true,
  email: 'autocongrats@yahoo.com',
  postsPerPage: 5, // Required
  social: {
    website: 'https://Ranta-cyber.github.io/blog/',
    github: 'https://github.com/Ranta-cyber',
    linkedin: 'https://linkedin.com/in/sirpa-merivalssi-7b7806130',
  },
  pathPrefix: '/blog',
  siteUrl: 'https://Ranta-cyber.github.io/blog/',
};
